import { AdministrationManager } from "src/modules/AdministrationManager/AdministrationManager";

export const AdministrationPage: React.FC = () => {
  return <AdministrationManager />;
};
